import { map, isFunction } from 'underscore';
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@fluentui/react-components';
import { List, ListItem } from '@fluentui/react-list-preview';
import { AddRegular, DeleteRegular } from '@fluentui/react-icons';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const CustomListItem = ({
  index,
  item,
  onItemChange,
  onItemRemove,
  onRenderItem,
}) => {
  const renderedItem = useMemo(() => onRenderItem({ item, onItemChange }), [item, onItemChange, onRenderItem]);

  return (
    <ListItem>
      {renderedItem}
      <Tooltip content="Remove" relationship="label">
        <Button
          style={{
            background: 'transparent',
            border: 'none',
            alignItems: 'start',
            marginLeft: '10px',
          }}
          className="list-remove-button"
          icon={<DeleteRegular />}
          onClick={() => onItemRemove(index)}
        />
      </Tooltip>
    </ListItem>
  );
};

CustomListItem.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({}).isRequired,
  onItemChange: PropTypes.func.isRequired,
  onItemRemove: PropTypes.func.isRequired,
  onRenderItem: PropTypes.func.isRequired,
};

export const EditableFluentList = ({
  items,
  onItemChange,
  onItemRemove,
  onRenderHeader,
  onRenderItem,
  onRenderFooter,
  addButtonText,
  onAddButtonClick,
}) => {
  const i18n = useContext(I18nContext);

  return (
    <>
      {isFunction(onRenderHeader) && items && items.length > 0 && onRenderHeader()}
      <List navigationMode="composite">
        {map(items, (item, index) => (
          <CustomListItem
            index={index}
            item={item}
            onItemChange={onItemChange(index)}
            onItemRemove={onItemRemove(index)}
            onRenderItem={onRenderItem}
          />
      ))}
      </List>
      {isFunction(onRenderFooter) && items && items.length > 0 && onRenderFooter()}
      <Button className="list-add-button" icon={<AddRegular />} style={{ marginTop: '20px' }} onClick={onAddButtonClick}>{addButtonText || i18n.getString(_TL_('Add'))}</Button>
    </>
  );
};

EditableFluentList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onItemChange: PropTypes.func.isRequired,
  onItemRemove: PropTypes.func.isRequired,
  onRenderHeader: PropTypes.func.isRequired,
  onRenderItem: PropTypes.func.isRequired,
  addButtonText: PropTypes.string.isRequired,
  onAddButtonClick: PropTypes.func.isRequired,
};
